import { render } from "./batch-input.vue?vue&type=template&id=3a47d7e7&scoped=true"
import script from "./batch-input.vue?vue&type=script&lang=js"
export * from "./batch-input.vue?vue&type=script&lang=js"

import "./batch-input.vue?vue&type=style&index=0&id=3a47d7e7&lang=scss&scoped=true"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a47d7e7"]])

export default __exports__